import { render, staticRenderFns } from "./getlotr.vue?vue&type=template&id=f2777356&scoped=true&"
import script from "./getlotr.vue?vue&type=script&lang=js&"
export * from "./getlotr.vue?vue&type=script&lang=js&"
import style0 from "./getlotr.vue?vue&type=style&index=0&id=f2777356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2777356",
  null
  
)

export default component.exports